<div class="plan-change-tab">
  <div class="plan-change-tab__intro">
    <h2 class="plan-change-tab__title">Membership plan changes</h2>
    <p class="plan-change-tab__description">
      Lets this company's attendants upgrade or downgrade a membership from the Active Subscription
      screen, with charges and refunds prorated for the rest of the cycle. Turn it on for the whole
      company or only for some of its locations.
    </p>
  </div>

  <div class="plan-change-tab__state" *ngIf="!source">Loading company…</div>

  <div class="plan-change-tab__card" *ngIf="source">
    <app-plan-change-settings [isActive]="true" [source]="source"></app-plan-change-settings>
  </div>
</div>
